import React from 'react';
import Icon from '../../../AppIcon';

const PerformanceOverview = ({ performanceData }) => {
  const { totalReferrals, successfulMatches, totalEarnings, conversionRate, activePrograms, pendingPayouts } = performanceData;

  const overviewCards = [
    {
      title: 'Total Referrals',
      value: totalReferrals,
      icon: 'Users',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      change: '+12%',
      changeType: 'positive'
    },
    {
      title: 'Successful Matches',
      value: successfulMatches,
      icon: 'CheckCircle',
      color: 'text-green-600',
      bgColor: 'bg-green-50',
      change: '+8%',
      changeType: 'positive'
    },
    {
      title: 'Total Earnings',
      value: `$${totalEarnings?.toLocaleString()}`,
      icon: 'DollarSign',
      color: 'text-emerald-600',
      bgColor: 'bg-emerald-50',
      change: '+15%',
      changeType: 'positive'
    },
    {
      title: 'Conversion Rate',
      value: `${conversionRate}%`,
      icon: 'TrendingUp',
      color: 'text-purple-600',
      bgColor: 'bg-purple-50',
      change: '+3%',
      changeType: 'positive'
    },
    {
      title: 'Active Programs',
      value: activePrograms,
      icon: 'Briefcase',
      color: 'text-orange-600',
      bgColor: 'bg-orange-50',
      change: '+2',
      changeType: 'positive'
    },
    {
      title: 'Pending Payouts',
      value: `$${pendingPayouts?.toLocaleString()}`,
      icon: 'Clock',
      color: 'text-amber-600',
      bgColor: 'bg-amber-50',
      change: '+5%',
      changeType: 'positive'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {overviewCards?.map((card, index) => (
        <div key={index} className="bg-card rounded-lg border border-border p-6 hover:shadow-md transition-shadow duration-200">
          <div className="flex items-center justify-between mb-4">
            <div className={`p-3 rounded-lg ${card?.bgColor}`}>
              <Icon name={card?.icon} size={24} className={card?.color} />
            </div>
            <div className={`flex items-center text-sm ${card?.changeType === 'positive' ? 'text-green-600' : 'text-red-600'}`}>
              <Icon name={card?.changeType === 'positive' ? 'ArrowUp' : 'ArrowDown'} size={16} className="mr-1" />
              {card?.change}
            </div>
          </div>
          <div>
            <h3 className="text-2xl font-bold text-foreground mb-1">{card?.value}</h3>
            <p className="text-sm text-muted-foreground">{card?.title}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PerformanceOverview;